<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="99" height="90" viewBox="0 0 99 90">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g :fill="color" fill-rule="nonzero">
        <g>
          <path
            d="M84.864 0H68.755c-1.52 0-2.787 1.088-3.074 2.533L13.245 18.172C11.913 18.569 11 19.799 11 21.196v30.383c0 .157.014.316.038.476l.013.088c.023.13.052.26.092.39L22.12 87.787c.42 1.35 1.657 2.213 2.992 2.213.31 0 .625-.047.937-.145L42.03 84.83c.794-.25 1.457-.806 1.843-1.548.385-.74.462-1.606.214-2.405L38.236 62.07l27.445 8.187c.287 1.444 1.554 2.533 3.074 2.533h16.109c1.732 0 3.136-1.413 3.136-3.154V3.154C88 1.412 86.596 0 84.864 0zM17.272 23.55L65.619 9.13V63.66l-31.226-9.316-.022-.006-17.1-5.101V23.55zm19.893 56.2l-9.998 3.144-8.28-26.596 12.105 3.611 6.173 19.84zM81.728 66.48h-9.837V6.308h9.837v60.173zM3 18c-1.657 0-3 1.424-3 3.18v30.64C0 53.576 1.343 55 3 55s3-1.424 3-3.18V21.18C6 19.423 4.657 18 3 18zM96 19c-1.657 0-3 1.413-3 3.156v27.688C93 51.587 94.343 53 96 53s3-1.413 3-3.156V22.156C99 20.413 97.657 19 96 19z"
            transform="translate(-748 -240) translate(748 240)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
